import { DHLError, axiosRequest, handleHttpResponse, getCurrentDate } from '@general/js/utils';
import { Services } from '../Services';

export default class PremiumImpactServices {
  /**
   * Retrieves the premium adjustment prices and dates for the Premium Adjustment timeline
   * @param {string} memberNumber member number or policy number
   * @param {boolean} showPremiumPaymentAmount whether the premium payment amount is to be included in response
   * @param {string} currentDate current date in 'YYYY-MM-DD'
   * @returns
   */
  static async getPremiumAdjustmentPrices(memberNumber, showPremiumPaymentAmount, currentDate = getCurrentDate()) {
    try {
      const response = await axiosRequest().post(Services.PREMIUM_IMPACT.GET_PREMIUM_ADJUSTMENT_PRICES_CRM, { memberNumber, showPremiumPaymentAmount, currentDate });

      if (handleHttpResponse(response) && response.data.responseString) {
        return JSON.parse(response.data.responseString);
      }

      throw new DHLError(`Issue with the response: ${response}`);
    } catch (error) {
      throw new DHLError(`getPremiumAdjustmentPrices() - Call failed with error`);
    }
  }
}
